import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import * as _m from 'moment';
import { Subscription } from 'rxjs';
import { Database, Entry } from 'src/app/_shared/models/publication-search.model';
import { PublicationService } from 'src/app/dataset/selectContent/publication-refinecontent/publication-results/publication-refinement.service';
import { CheckBoxItem } from '../checkbox-group/checkboxItem';
import * as JsSearch from 'js-search';
import { PubSelectModalComponent } from './pubselectmodal.component';
import { MatDialog } from '@angular/material/dialog';
import { Facet, PubFacetResponseType } from 'src/app/_shared/models/publication-results.model';
import { LOCAL_STORAGE_KEYS } from 'src/app/shared/constants/storage-keys';

type AppliedFilterType = 'pub' | 'st' | 'doc' | 'db' | 'date';

interface AppliedFilter {
  type: AppliedFilterType;
  value: string;
}



@Component({
    selector: 'tdms-filterpanel',
    templateUrl: './filterpanel.component.html',
    styleUrls: ['./filterpanel.component.scss'],
    standalone: false
})
export class FilterpanelComponent implements OnInit, AfterViewInit, OnDestroy {

  pubFacets: Entry[] = [];
  @Input() sourceFacets: Entry[] = [];
  @Input() docFacets: Entry[] = [];
  @Input() dbFacets: Entry[] = [];
  @Input() isWb = false;

  @Output() componentRendered: EventEmitter<void> = new EventEmitter<void>();
  @Output() jumpToResultsTriggered: EventEmitter<void> = new EventEmitter<void>();

  displayFilters$ = this.pubservice.displayFilter$;
  lazyPubFacetSubject$ = this.pubservice.lazyPubFacetSubjectV1$;




  

  showApplyFilters = false;
  showApplyFiltersForDates = false;
  showApplyFiltersForFullTextLimiter = false;

  @ViewChild('aFilters',{static: false}) aFiltersEl?: ElementRef;
  @Output() isApplyFilterTriggered = new EventEmitter<boolean>();
  @HostListener('window:keydown.space', ['$event'])
    spaceEvent(event: any) {
        if(event.target.className == "checkbox"){
          event.preventDefault();
        }
    }
  
  
  initialLoad = false;
  docCount = 0;
  sourceCount = 0;
  currentPubSearch = "";
  filterValue = '';
  showApplied = false;
  isExpandable = false;
  
  pubFacetSelection: CheckBoxItem[] = [];
  pubFilterSelection: CheckBoxItem[] = [];

  docFacetSelection: CheckBoxItem[] = [];
  docList: CheckBoxItem[] = [];

  sourceFacetSelection: CheckBoxItem[] = [];
  sourceList: CheckBoxItem[] = [];

  dbFacetSelection: CheckBoxItem[] = [];
  dbList: CheckBoxItem[] = [];



  //User selected filters;
  selectedPubFilterValues: {
    id: string;
    title: string;
  } []  = [];
  selectedDocFilterValues: string[] = [];
  selectedSourceTypeFilterValues: string[] = [];
  selectedModalDbFilterValues: Database[] = [];
  appliedFilters: AppliedFilter[] = [];
  selectedDbDisplayValues: { displayValue: string; value: string }[] = [];

  dateFilterSubscription: Subscription | null = null;
  fullTextLimiterSubscription: Subscription | null = null;

  isPubFacetLoading =  true;
  isdbFacetLoading = true;

  
  
  

  constructor(private pubservice: PublicationService, private dialog: MatDialog, private cdr:ChangeDetectorRef) {}


  ngOnInit() {
    console.log('FilterPanel component ---- ngOnInit method...');
    //populate docFacetCheckboxModel...
    //this.pubFacetSelection = this.pubFacets ? this.pubFacets.map( entry => new CheckBoxItem(entry.searchValue, entry.displayValue, entry.count)) : [];
    //this.pubFilterSelection = this.pubFacetSelection;

    this.docFacetSelection = this.docFacets ? this.docFacets.map( entry => new CheckBoxItem(entry.searchValue, entry.displayValue, entry.count))  : [];
    this.docList = this.docFacetSelection.length < 12 ? this.docFacetSelection : this.docFacetSelection.slice(0,12);
    this.docCount = this.docFacetSelection.length - this.docList.length;

    this.sourceFacetSelection = this.sourceFacets ? this.sourceFacets.map( entry => new CheckBoxItem(entry.searchValue, entry.displayValue, entry.count))  : [];
    this.sourceList = this.sourceFacetSelection.length < 12 ? this.sourceFacetSelection : this.sourceFacetSelection.slice(0,12);
    this.sourceCount = this.sourceFacetSelection.length - this.sourceList.length;

    //this.dbFacetSelection = this.dbFacets ? this.dbFacets.map( entry => new CheckBoxItem(entry.searchValue, entry.displayValue, entry.count)) : [];

    this.initialLoad = true;
    this.populatedSelectedFilterValues();
    this.dateFilterSubscription = this.pubservice.dateFilter$.subscribe(val => {
      this.showApplyFiltersForDates = this.pubservice.isDatesSelected();
    })
    this.fullTextLimiterSubscription = this.pubservice.fullTextLimitter$.subscribe(val => {
      this.showApplyFiltersForFullTextLimiter = val;
    })
    

    //Load pubFaceet & DBFacet section lazily....
    this.lazyPubFacetSubject$.subscribe( (pubFacetResp: PubFacetResponseType) => {

      if(pubFacetResp.type === 'start') {
        this.isPubFacetLoading = true;
      }

      if(pubFacetResp.type === 'finish') {
        this.isPubFacetLoading = false;
        if(pubFacetResp.searchResp) {
          this.pubFacets = this.pubservice.getPubFacets(pubFacetResp.searchResp.facets);
          localStorage.setItem(LOCAL_STORAGE_KEYS.PUB_FACETS, JSON.stringify(this.pubFacets));
          this.pubFacetSelection = this.pubFacets ? this.pubFacets.map( entry => new CheckBoxItem(entry.searchValue, entry.displayValue, entry.count)) : [];
          console.log('filterPanel init method...', this.pubFacets.length, ' ', this.isPubFacetLoading);
        }
        
      }
      
    })


  }


  ngAfterViewInit() {
    if(this.aFiltersEl){this.isExpandable = this.aFiltersEl.nativeElement.offsetHeight > 340;}
    this.cdr.detectChanges();

    this.componentRendered.emit();
  }




  onDocFacetChange(values: string[]) {
    this.selectedDocFilterValues = values;
    this.initialLoad = false;
    this.showApplyFilters = true;

  }

  onSourceTypeFacetChange(values: string[]) {
    this.selectedSourceTypeFilterValues = values;
    this.initialLoad = false;
    this.showApplyFilters = true;

  }


  // onDbFacetChange(values) {
  //   this.selectedDbDisplayValues = [];
  //   for(let val of values){
  //     this.selectedDbDisplayValues.push({displayValue:this.dbFacetSelection.find(x => x.value == val).label, value: val})
  //   }
  //   this.selectedDbFilterValues = values;
  //   this.initialLoad = false;
  //   this.showFilterButton();
  //   this.showApplyFilters = true;

  // }

  onPublicationFacetChange(values: { id: string; title: string }[]) {
    this.selectedPubFilterValues = values;
    this.initialLoad = false;
    this.pubservice.setFilterChecked(true);
    this.showApplyFilters = true;
  }


  private populatedSelectedFilterValues() {
    const pubFilters = localStorage.getItem(LOCAL_STORAGE_KEYS.PUB_FILTERS);
    const docFilters = localStorage.getItem(LOCAL_STORAGE_KEYS.DOC_FILTERS);
    const sourceFilters = localStorage.getItem(LOCAL_STORAGE_KEYS.SOURCE_FILTERS);
    const dbFilters = localStorage.getItem(LOCAL_STORAGE_KEYS.DB_FILTERS);

    this.selectedPubFilterValues = pubFilters ? JSON.parse(pubFilters) : [];
    this.selectedDocFilterValues = docFilters ? JSON.parse(docFilters) : [];
    this.selectedSourceTypeFilterValues = sourceFilters ? JSON.parse(sourceFilters) : [];
    this.selectedModalDbFilterValues = dbFilters ? JSON.parse(dbFilters) : [];
    this.popluateAppliedFilter();
  }


  popluateAppliedFilter(){
    for(const pub of this.selectedPubFilterValues){
      this.appliedFilters.push({type: 'pub', value: pub.title})
    }
    for(const st of this.selectedSourceTypeFilterValues){
      this.appliedFilters.push({type: 'st', value: st})
    }
    for(const doc of this.selectedDocFilterValues){
      this.appliedFilters.push({type: 'doc', value: doc})
    }
    for(const db of this.selectedModalDbFilterValues){
      if (db.name) {
        this.appliedFilters.push({type: 'db', value: db.name})
      }
    }
    //Date filter
    const dateCard = localStorage.getItem(LOCAL_STORAGE_KEYS.YEAR_CARD_SEL);
    if(dateCard){
      this.appliedFilters.push({type: 'date', value: dateCard == '1' ? dateCard + " Year" : dateCard + " Years"});
    } else {
      const fromDate = localStorage.getItem(LOCAL_STORAGE_KEYS.FROM_DATE);
      const toDate = localStorage.getItem(LOCAL_STORAGE_KEYS.TO_DATE);
      const fDate = fromDate ? JSON.parse(fromDate) as string : null;
      const tDate = toDate ? JSON.parse(toDate) as string : null;
      let date = '';

      if(fDate != null && fDate.length>0 ) {
        const tmpFdate = fDate.substring(0,10).split('-');
        const formattedFromDate = tmpFdate[1] + '/' + tmpFdate[2] + '/' + tmpFdate[0];
        date = tDate ? formattedFromDate + ' - ' : 'after ' + formattedFromDate;
      }

      if(tDate !=null && tDate.length>0) {
        const tmpTdate = tDate.substring(0,10).split('-');
        const formattedToDate = tmpTdate[1] + '/' + tmpTdate[2] + '/' + tmpTdate[0];
        date = fDate ? date + formattedToDate : 'before ' + formattedToDate;
      }
      if(date){this.appliedFilters.push({type: 'date', value: date});}
    }
  }

  clearFilter(filter: AppliedFilter){
    switch(filter.type) {
      case 'pub': {
        this.selectedPubFilterValues = this.selectedPubFilterValues.filter(pub => pub.title !== filter.value);
        break;
      }
      case 'date': {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.TO_DATE);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.FROM_DATE);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.YEAR_CARD_SEL);
        break;
      }
      case 'st': {
        this.selectedSourceTypeFilterValues = this.selectedSourceTypeFilterValues.filter(st => st !== filter.value);
        break;
      }
      case 'doc': {
        this.selectedDocFilterValues = this.selectedDocFilterValues.filter(doc => doc !== filter.value);
        break;
      }
      case 'db': {
        this.selectedModalDbFilterValues = this.selectedModalDbFilterValues.filter(db => (db.name ?? '') !== filter.value);
        break;
      }

    }
    this.applyFilters();
  }

  applyFilters(){
    
    localStorage.setItem(LOCAL_STORAGE_KEYS.SOURCE_FILTERS, JSON.stringify(this.selectedSourceTypeFilterValues));
    localStorage.setItem(LOCAL_STORAGE_KEYS.DOC_FILTERS, JSON.stringify(this.selectedDocFilterValues));
    localStorage.setItem(LOCAL_STORAGE_KEYS.PUB_FILTERS, JSON.stringify(this.selectedPubFilterValues));
    localStorage.setItem(LOCAL_STORAGE_KEYS.DB_FILTERS, JSON.stringify(this.selectedModalDbFilterValues));
    localStorage.setItem(LOCAL_STORAGE_KEYS.DB_DISPLAY_FILTERS, JSON.stringify(this.selectedDbDisplayValues));

    const tempToDate = localStorage.getItem(LOCAL_STORAGE_KEYS.T_DATE);
    if(tempToDate){
      localStorage.setItem(LOCAL_STORAGE_KEYS.TO_DATE, tempToDate); 
      localStorage.removeItem(LOCAL_STORAGE_KEYS.T_DATE);
    }
    const tempFromDate = localStorage.getItem(LOCAL_STORAGE_KEYS.F_DATE);
    if(tempFromDate){
      localStorage.setItem(LOCAL_STORAGE_KEYS.FROM_DATE, tempFromDate);
      localStorage.removeItem(LOCAL_STORAGE_KEYS.F_DATE);
    }
    this.triggerFilters();
    // setTimeout(() => this.jumpToResults(new Event('click')), 1500);
  }

  triggerFilters() {
    this.isApplyFilterTriggered.emit(true);
  }

  clearAllFilters() {
    this.pubservice.clearFilters();
    this.triggerFilters();
  }

  public displayClearFilters(): boolean | false {
    return this.pubservice.displayClearFilters();

  }

  ngOnDestroy() {
    console.log('FilterPanel component destroyed ---- ngONeDestory method...');
    if(this.dateFilterSubscription != null)
      this.dateFilterSubscription.unsubscribe();
    if(this.fullTextLimiterSubscription != null)
      this.fullTextLimiterSubscription.unsubscribe();
  }

  applySearchFilter(filterValue: string) {
    if(filterValue === this.currentPubSearch){ return }

    this.currentPubSearch = filterValue;

    const copyAllPubs:CheckBoxItem[] =  [...this.pubFacetSelection];


    const searcher = new JsSearch.Search('label');
    searcher.indexStrategy = new JsSearch.AllSubstringsIndexStrategy();
    searcher.addIndex('value');
    searcher.addIndex('label');
    searcher.addDocuments(copyAllPubs);
    


    /***
     * TODO: What is this doing.????
     * temporarly commenting it out.
     */
    // if(filterValue !=null && filterValue.length == 0) {
    //   this.pubFilterSelection = copyAllPubs;
    //   results = copyAllPubs;
    // } else {
    //   results =  searcher.search(filterValue);
    // }

    //  this.pubFilterSelection =  results;

  }

  clearSearchFilter(event: string) {
    const filterValue =  event;

    if(filterValue !=null && filterValue.length== 0) {
      this.applySearchFilter(filterValue);
    }
  }

  jumpToResults(event: Event) {
    event.preventDefault();
    this.jumpToResultsTriggered.emit();

    const resultsContainer = document.getElementById('jumpToResults-0') as HTMLElement | null;
    if (!resultsContainer) {
      return;
    }

    if (!resultsContainer.hasAttribute('tabindex')) {
      resultsContainer.setAttribute('tabindex', '-1');
    }
    
    resultsContainer.focus();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  
  showMore(type:'source' | 'doc'){
    if(type === 'source'){
      this.sourceList = this.sourceFacetSelection;
    } else if (type === 'doc') {
      this.docList = this.docFacetSelection;
    }
  }

  onViewPubs(filterType:'pub' | 'database'){
    const dialogRef = this.dialog.open(PubSelectModalComponent, {
                                       disableClose: false, 
                                       width: '1175px', 
                                       maxWidth:'98vw',  
                                       maxHeight: '90vh', 
                                       data: {
                                        isWb: this.isWb,
                                        filterType: filterType, 
                                        filters: filterType == "pub" ? Object.assign([],this.selectedPubFilterValues) : Object.assign([],this.selectedModalDbFilterValues)
                                      }});
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.event == 'pubSelect'){

        this.selectedPubFilterValues = result.data;
        this.applyFilters();
      } else if (result && result.event == 'dbSelect'){
        this.selectedModalDbFilterValues = result.data;
        this.applyFilters();
      }
    })
  }
}

